import { isDefined } from '@aloft/toolkit-shared';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ReconciliationSheetFormOutput } from '../../modules/referenceView/ReconciliationSheet/schemas.ts';
import { ReconciliationState, SyncResult } from '../types.ts';
import { getBumpedSyncState } from './utils/getBumpedSyncState.ts';
import { clearOrder } from './actions/clearOrder.ts';

export const initialReconciliationState: ReconciliationState = {
  opinionOfMarketValue: undefined,
  includeTotalCostToCure: false,
  includeOpinionOfAfterRepairValue: false,
  includeTotalRenovationBudget: false,
  totalCostToCure: undefined,
};

const reconciliationSlice = createSlice({
  name: 'reconciliation',
  initialState: initialReconciliationState,
  reducers: {
    submitReconciliationDataSheet: (
      state,
      action: PayloadAction<ReconciliationSheetFormOutput>,
    ) => {
      const { opinionOfMarketValue, totalCostToCure } = action.payload;

      Object.assign(state, {
        syncState: getBumpedSyncState(state.syncState),
        opinionOfMarketValue,
        totalCostToCure,
      });
    },
    submitReconciliation: (state, action) => {
      const { opinionOfMarketValue, totalCostToCure } = action.payload;
      state.opinionOfMarketValue = opinionOfMarketValue;
      state.totalCostToCure = totalCostToCure;
      state.syncState = getBumpedSyncState(state.syncState);
    },
    setReconciliation: (state, action: PayloadAction<ReconciliationState>) => {
      Object.assign(state, {
        includeTotalCostToCure: action.payload.includeTotalCostToCure,
        opinionOfMarketValue: action.payload.opinionOfMarketValue,
        totalCostToCure: action.payload.totalCostToCure,
        syncState: {
          editRevision: 0,
          serverRevision: 0,
          status: 'success'
        }
      });
    },
    reconciliationMutationComplete: (state, action: PayloadAction<SyncResult>) => {
      const { payload } = action;
      const { status } = payload;

      if (isDefined(state.syncState)) {
        Object.assign(state.syncState, { status });

        if (status === 'success') {
          Object.assign(state.syncState, { serverRevision: payload.serverRevision });
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearOrder, () => initialReconciliationState);
  },
});

export const {
  submitReconciliation,
  submitReconciliationDataSheet,
  reconciliationMutationComplete,
  setReconciliation,
} = reconciliationSlice.actions;
export const reconciliationReducer = reconciliationSlice.reducer;
